import { render, staticRenderFns } from "./KnowledgeTable.vue?vue&type=template&id=68043d1a&scoped=true&"
import script from "./KnowledgeTable.vue?vue&type=script&lang=js&"
export * from "./KnowledgeTable.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeTable.vue?vue&type=style&index=0&id=68043d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68043d1a",
  null
  
)

export default component.exports